/**
 * Accessibility helpers for timer readouts.
 *
 * Keeps visible timer formatting separate from screen-reader labels so passive
 * countdowns can expose meaningful remaining-time text.
 *
 * @module timerAccessibility
 */

export interface TimerAriaLabelText {
  readonly prefix: string;
  readonly minute: string;
  readonly minutes: string;
  readonly second: string;
  readonly seconds: string;
  readonly warning?: string;
}

export function formatTimerAriaLabel(
  totalSeconds: number,
  labels: TimerAriaLabelText,
): string {
  const safeSeconds = Math.max(0, Math.floor(totalSeconds));
  const minutes = Math.floor(safeSeconds / 60);
  const seconds = safeSeconds % 60;
  const minuteUnit = minutes === 1 ? labels.minute : labels.minutes;
  const secondUnit = seconds === 1 ? labels.second : labels.seconds;
  const baseLabel = `${labels.prefix}: ${minutes} ${minuteUnit} ${seconds} ${secondUnit}`;

  return labels.warning ? `${baseLabel} - ${labels.warning}` : baseLabel;
}
